import { useTranslation } from 'react-i18next'
import { PhoneIcon } from '@untitledui-icons/react/solid'
import { hasWhatsAppMessages, isWhatsAppOrigin } from '@/lib/conversationChannel'
import { getInboxChannelLabelKey, type ChannelConversation } from './inboxChannel'
import { WhatsAppIcon } from '../components/ChannelIcons'

export function InboxChannelIcons({ conversation }: { conversation: ChannelConversation }) {
  const { t } = useTranslation()
  const phone = !isWhatsAppOrigin(conversation)
  const whatsapp = hasWhatsAppMessages(conversation)

  return (
    <span className="flex shrink-0 items-center" aria-label={t(getInboxChannelLabelKey(conversation))}>
      {phone && (
        <span className="relative z-10 flex size-4 items-center justify-center rounded-full bg-[#3c93de]">
          <PhoneIcon className="size-2 text-white" aria-hidden="true" />
        </span>
      )}
      {whatsapp && (
        <span
          className={
            phone
              ? '-ml-1 flex size-4 items-center justify-center rounded-full bg-[#25D366]'
              : 'flex size-4 items-center justify-center rounded-full bg-[#25D366]'
          }
        >
          <WhatsAppIcon className="size-2.5 text-white" />
        </span>
      )}
    </span>
  )
}
